import { render, staticRenderFns } from "./register-result.vue?vue&type=template&id=ac742d18&"
import script from "./register-result.vue?vue&type=script&lang=js&"
export * from "./register-result.vue?vue&type=script&lang=js&"
import style0 from "./register-result.vue?vue&type=style&index=0&id=ac742d18&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports